import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import SuccessAlertModal from "../Modals/successAlertModal";
import { useLocation, useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import { ICONS } from "../utility/common/constants/icons";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import Pdf_Download from "./PDF/Pdf_Download";
import { DeleteGroove, getGridHeaderData } from "../../Services/wps_groove-services";
import Toaster, { showWarning, showSuccess as showSuccessToast } from "../utility/ui/notifications/Toaster";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { checkWPSNoPresent } from "../../Services/wcs-services";
import { GridLoader } from "react-spinners";
import { Status } from "../utility/common/constants/CommonConstants";

const WPSGroove_Overlay = forwardRef((props, ref) => {
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [Groove, setGroove] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [cancel, setCancel] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  let userprofile = sessionStorage.getItem("UserProfile");
  let Band = sessionStorage.getItem("Band");
  const [WPStype] = useState(props.type);
  const [userObj, setuserObj] = useState("");
  const [loading, setLoading] = useState(true);
  const childRef = useRef();
  const year = new Date().getFullYear();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const msg = "";
  const history = useNavigate();

  
  const tmpcolumnDefs = [
    {
      headerName: "Status",
      field: "WPSH_Status",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "WPSCellRenderer",
      sort: "desc",
      minWidth: 200
    },
    {
      headerName: "Project No.",
      field: "WPSH_Project_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "WPS Number",
      field: "WPSH_WPS_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Supporting PQR",
      field: "WPSH_SupportingPQR",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Process",
      field: "WPSH_WPS_Process",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Pno.",
      field: "WPSH_BM_Type_PNo",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "WPS Change No.",
      field: "WPS_Change_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
  ];

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchGroove = async () => {
    const startYear = parseInt(process.env.REACT_APP_START_YEAR) || 2023;
    const currentYear = new Date().getFullYear();
    
    // Create array of years in descending order
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }

    // Fetch all years in parallel
    const promises = years.map(year => 
      getGridHeaderData(
        WPStype,
        sessionStorage.getItem("Band"),
        sessionStorage.getItem("User"),
        year
      )
    );

    const results = await Promise.all(promises);
    
    // Combine results maintaining year order
    const allResults = results.flat().filter(Boolean);

    setGroove(allResults);
    setLoading(false);
    setFilteredResult(allResults);
  };


  const fetchColumnDefns = async () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result.push({
      headerName: "", cellRenderer: actionRenderer, minWidth: 260, suppressMenu: true,
      sortable: false,
    });

    setColumnDefs(result);
  };

  useEffect(() => {
    fetchGroove();
    fetchColumnDefns();
  }, [cancel]);

  function handleClick() {
    if (WPStype === "Groove") {
      navigate("/wps/Groove/Groovetrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Overlay") {
      navigate("/wps/Overlay/Overlaytrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Tubesheet") {
      navigate("/wps/Tubesheet/Tubesheettrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    }
  }

  function handleClickedit(row) {
    if (row.WPSH_Status === "Approved") {
      row.WPS_Change_No = String(Number(row.WPS_Change_No) + 1);
    }

    if (WPStype === "Groove") {
      navigate("/wps/Groove/Groovetrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    } else if (WPStype === "Overlay") {
      navigate("/wps/Overlay/Overlaytrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    } else if (WPStype === "Tubesheet") {
      navigate("/wps/Tubesheet/Tubesheettrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    }
  }

  function handleClickcopy(row) {
    if (WPStype === "Tubesheet") {
      navigate("/wps/Tubesheet/Tubesheettrans", {
        state: { data: row, action: "Copy", WPStype: WPStype },
      });
    } else {
      navigate("/wps/Groove/Groovetrans", {
        state: { data: row, action: "Copy", WPStype: WPStype },
      });
    }
  }

  function handleClickTemp(row) {
    navigate("/wps/Groove/Groovetrans", {
      state: { data: row, action: "Temp", WPStype: WPStype },
    });
  }

  useImperativeHandle(ref, () => ({
    handleAdd: () => {
      handleClick();
    },
  }));

  const modalOnClick = () => {
    history("/");
  };

  const handleCloseSuccess = () => setShowSuccess(false);

  const handleGlobalSearch = (text) => {
    let searchText = text.toLowerCase();
    childRef.current.setSearch(searchText);
  };

  const handleGlobalExport = () => {
    if (WPStype === "Groove") {
      let filename = "WpsGrooveTransaction";
      handleExport1(filteredResult, filename, tmpcolumnDefs);
    } else if (WPStype === "Overlay") {
      let filename = "WpsOverlayTransaction";
      handleExport1(filteredResult, filename, tmpcolumnDefs);
    } else {
      let filename = "WpsTubesheetTransaction";
      handleExport1(filteredResult, filename, tmpcolumnDefs);
    }
  };

  const handlepdf = (row) => {
    if (row?.WPSH_Status === Status.StatusApproved || row?.WPSH_Status === Status.StatusPending) {
      setAction("pdf");
      setRowData(row);
      setShowForm(true);
      setuserObj(userprofile);
    }
    else {
      showWarning("Cannot Print PDF.Please Approve the Record")
    }
  };

  let isPresent;

  const handleDeleteEvent = (row) => {
    setDeleteRow(row);
    setShowConfirm(true);
  };

  const handleConfirmDelete = async () => {
    try {
      let gridDetail = {
        WCS_Project_No: deleteRow.WPSH_Project_No,
        WPSH_WPS_No: deleteRow.WPSH_WPS_No,
      };
      isPresent = await checkWPSNoPresent(gridDetail);

      if (isPresent) {
        showWarning("WPS already in use, cannot be deleted");
      } else {
        setRowData(deleteRow);
        deleteRow.WI_Slip_Status = "Deleted";
        await DeleteGroove(deleteRow);
        showSuccessToast(`WPS record ${deleteRow.WPSH_WPS_No} has been deleted`);
        setCancel(true);
      }
    } catch (error) {
      console.error("Deletion failed:", error);
    } finally {
      setShowConfirm(false);
      setDeleteRow(null);
    }
  };

  const actionRenderer = (params) => {
    let actions = [];
    if (params.data.WPSH_Status === "Approved") {
      actions = ['delete', 'edit', 'export', 'copy', 'temp']
    }
    else {
      actions = ['delete', 'edit', 'copy', 'temp']
    }

    return (
      <UnifiedActionRenderer
        actions={actions}
        selectedData={params}
        handleDeleteEvent={(params) => handleDeleteEvent(params.data)}
        handleEditEvent={(params) => handleClickedit(params.data)}
        handlePdfEvent={(params) => handlepdf(params.data)}
        handleCopyEvent={(params) => handleClickcopy(params.data)}
        handleTempEvent={(params) => handleClickTemp(params.data)}
      />
    );
  };



  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Container fluid>
        <SuccessAlertModal
          clickFunction={modalOnClick}
          msg={msg}
          show={showSuccess}
          handleClose={handleCloseSuccess}
        />
        <ConfirmAlertModal
          action="Delete"
          handleYes={handleConfirmDelete}
          formName={`WPS ${deleteRow?.WPSH_WPS_No}`}
          show={showConfirm}
          handleClose={() => setShowConfirm(false)}
        />
        <Row className="RowHeight">
          <Col md={2} sm={2} xs={2} className="ListTitle">
            WPS Transaction list
          </Col>
          <Col className="ListTitle">
            <div className="global-search-container">
              <GolbalSearch
                searchplaceholdertext={
                  "Search for " +
                  WPStype +
                  " Project No., WPS Number ,Supporting PQR,WPS Change No."
                }
                withYear={false}
                filterFunc={handleGlobalSearch}
              />
              <img
                className="allexport"
                src={ICONS.Export}
                alt="Export"
                onClick={handleGlobalExport}
              />
            </div>
          </Col>
        </Row>
        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          ref={childRef}
        />
        {showForm && (
          <Pdf_Download
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            fetchUserMaster={fetchGroove}
            setReload={setReload}
            reload={reload}
            userObj={userObj}
            allRecs={Groove}
            backdrop="static"
            Band={Band}
          />
        )}
        <Toaster />
      </Container>
    </>
  );
});

export default WPSGroove_Overlay;